export const responseMessage = {
  successSave: 'Successfully saved',
  errorSave: 'Failed to save',
  successUpdate: 'Successfully Updated',
  errorUpdate: 'Failed to update collection.',
  successArchive: 'Successfully archived collection.',
  errorArchive: 'Failed to archive collection.',
  successHide: 'Successfully hide message.',
  successUnhide: 'Successfully unhide message.',
  errorHide: 'Failed to hide message.',
  errorUnhide: 'Failed to unhide message.',
}

export const authenticationError = [
  'auth/invalid-email',
  'auth/user-not-found',
  'auth/internal-error',
  'auth/wrong-password',
]

export const authenticationErrorResponse = {
  invalid: 'Invalid email address or password.',
  // eslint-disable-next-line quotes
  serverError: "Something wen't wrong from the server, Please try again.",
}
